import React, { Fragment } from 'react';
import { IconUser } from '@zillow/constellation';

import { StyledIconBG, StyledImage, StyledUserIconText } from './style';

interface Props {
  firstName?: string;
  lastName?: string;
  userName?: string;
  email?: string;
  profileImageUrl?: string;
}

const UserIcon = ({ firstName, lastName, userName, email, profileImageUrl }: Props) => {
  let displayName = '';
  if (firstName && lastName) {
    displayName = `${firstName} ${lastName}`;
  } else if (firstName) {
    displayName = firstName;
  } else if (userName) {
    displayName = userName;
  } else if (email) {
    displayName = email;
  }
  return (
    <Fragment>
      <StyledIconBG>
        {
          // @ts-ignore
          profileImageUrl ? <StyledImage src={profileImageUrl} /> : <IconUser className="User-icon" size="xs" />
        }
      </StyledIconBG>
      <StyledUserIconText>{displayName}</StyledUserIconText>
    </Fragment>
  );
};

export default UserIcon;
